// Adminmanual: PDF-filen ligger i projektets public-mapp som adminmanual.pdf
const MANUAL_URL = '/adminmanual.pdf'

export function ManualPage() {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', flex: 1, overflow: 'hidden', minHeight: 0 }}>
      <div className="content-header">
        <div>
          <h1>Manual</h1>
          <div className="content-sub">Adminmanual för E.ON Schema</div>
        </div>
        <div style={{ display: 'flex', gap: 8 }}>
          <a className="btn btn-secondary btn-sm" href={MANUAL_URL} target="_blank" rel="noopener noreferrer">Öppna i ny flik</a>
          <a className="btn btn-primary btn-sm" href={MANUAL_URL} download="Adminmanual_EON_Schema.pdf">Ladda ner</a>
        </div>
      </div>
      <div style={{ flex: 1, minHeight: 0, padding: '0 24px 24px' }}>
        <iframe
          title="Adminmanual"
          src={`${MANUAL_URL}#view=FitH`}
          style={{ width: '100%', height: '100%', border: '1px solid #e4e4e4', borderRadius: 8, background: '#fff' }}
        />
      </div>
    </div>
  )
}
